/**
 * LESA Public JS
 */

// Import our imports
import select2 from 'select2';

(function ($) {
	function init() {
		console.log('LESA volunteer frontend JS loaded.');

		if ($('.js-volunteers-table').length) {
			initVolunteersTables();
		}

		if ($('.js-select2').length) {
			initSelect2();
		}

		// hide or show past programs on public profile
		const $pastProgramToggle = $('.js-toggle-past-programs');
		if ($pastProgramToggle.length) {
			$pastProgramToggle.click(function(event) {
				event.preventDefault();
				$('.js-past-program-history').fadeToggle();
			});
		}
	}

	function initSelect2 () {
		$('.js-select2').each(function() {
			$(this).select2({
				minimumResultsForSearch: 10,
				placeholder: $(this).data('placeholder'),
				allowClear: true
			});
		});
	}

	function initVolunteersTables(tableSize) {
		tableSize = tableSize || 20;

		$('.js-volunteers-table').footable({
			"paging": {
				"countFormat": "{PF} - {PL} of {TR}",
				"size": tableSize
			},
			"empty": "No Volunteers found"
		});

		// open volunteer modal
		document.body.addEventListener( 'click', function (event) {
			if (event.target.classList.contains('js-volunteer-modal-trigger')) {
				openVolunteerModal(event.target);
			}
		});

		// filter volunteer roles in modal
		$(document).on('change', '.js-filter-history', function(event) {
			filterVolunteerHistory(event.target);
		});

		// export csv of emails from filtered list
		document.body.addEventListener( 'click', function (event) {
			if (event.target.classList.contains('js-export-list')) {
				event.preventDefault();
				downloadVolunteerCSV();
			}
		});
	}

	/**
	 * Grabs the filtered rows' volunteer names + emails, writes a csv and downloads it
	 */
	function downloadVolunteerCSV() {
		let csvFileData = [];

		// get filtered results
		// ensure all paginated results are there
		let ft = FooTable.get('#js-volunteers-table');
		let rows = ft.rows.all;

		for (let i = 0, l = rows.length, row; i < l; i++) {
			row = rows[i];
			row.draw();

			const name = $(row.$el[0]).find('.js-volunteer-name').text().trim();
			const email = $(row.$el[0]).find('.js-volunteer-email').text().trim();

			csvFileData.push([
				name,
				email
			]);
		}

		//define the heading for each row of the data
		let csv = 'Name,Email\n';

		//merge the data with CSV
		csvFileData.forEach(function(row) {
			csv += row.join(',');
			csv += "\n";
		});

		// create a new tab and dump csv contents to tab and trigger download of csv
		// - displays the created CSV data on the web browser
		let hiddenElement = document.createElement('a');
		hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
		hiddenElement.target = '_blank';

		//provide the name for the CSV file to be downloaded
		hiddenElement.download = 'Filtered Volunteers.csv';
		hiddenElement.click();
	}

	function openVolunteerModal(trigger) {
		const volunteerId = trigger.dataset.volunteerId;

		var data = {
			'action': 'load_volunteer',
			'volunteer_id': volunteerId,
			'nonce': lesa_volunteer_custom_params.volunteers_nonce
		};

		$.ajax({
			url : lesa_volunteer_custom_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
		}).done((data) => {
			if (data) {
				$('#volunteer-modal-content').html(data);
			} else {
				let content = '<p class="modal-message">Volunteer could not be found</p>';
				$('#volunteer-modal-content').html(content);
			}

			// todo: lets open content and fade in
			MicroModal.show('volunteer-modal');

			// enable select 2 in modal
			const $roleFilter = $('.js-filter-history');

			if ($roleFilter.length) {
				$roleFilter.select2({
					minimumResultsForSearch: 10,
					placeholder: $(this).data('placeholder'),
					allowClear: true
				});
			}
		}).fail((xhr, ajaxOptions, thrownError) => {
			console.log(xhr.status);
			console.log(thrownError);
		});
	}

	function filterVolunteerHistory(filter) {
		// get selected value
		const $filter = $(filter);
		const $filteredType = $filter.val();

		// get sibling history
		const $historyItems = $filter.parent().siblings('.js-volunteer-history').children('.js-history-item');

		// reveal all || hide all but selected
		if ($filteredType.includes('All') || !$filteredType) {
			$historyItems.fadeIn();
		} else {
			$historyItems.fadeOut();

			// hide or show all elements based on data attribute
			$historyItems.each(function() {
				let matches = $filteredType.includes($(this).data('history-type'));

				if (matches) {
					$(this).fadeIn();
				}
			});
		}
	}

	// todo: add ajax filterVolunteers

	// todo: wishlist: add clear projects functionality w/o refresh by emptying form and calling filterVolunteers

	/* Document ready
	/* + + + + + + + + + + + + + + + + + + + + + + + + + + + */

	$(function() {
		init();
	});
})(jQuery);
